import axios from "axios";
import { config } from '../config.env'
import { notifyError } from "../components/NotifyToast";

const platform = config.PLATFORM;
const endpoint = config.ENDPOINT;

/*
export function getInformation(pid, hospitalId = "") {
    return new Promise((resolve) => {
        const paths = [
            "/personal_information",
            "/diag_information",
            "/order_information",
            "/visit_information",
            "/lab_information",
        ];
        const keys = [
            "personal_information_list",
            "diagnosis_information_list",
            "order_information_list",
            "visit_information_list",
            "labs_information_list",
        ];
        const header = {
            Platform: platform,
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        };
        let result = {};
        let len = paths.length;

        for (let i = 0; i < len; i++) {
            const url = `${endpoint}/health-atm/information/findInformation?pid=${pid}`;
            const promise = axios.get(url, { headers: header }).then((res) => {
                if (res.data.code !== 200) {
                    notifyError(res.data.message);
                    throw new Error(res.data.message);
                }
                return res.data.data;
            });
            result[keys[i]] = promise;
        }

        Promise.all(Object.values(result))
            .then((resolvedData) => {
                const resultDict = {};
                keys.forEach((key, index) => {
                    resultDict[key] = resolvedData[index];
                });
                resolve(resultDict);
            })
            .catch((error) => {
                resolve(false);
            });
    });
}
*/

export function getInformation(pid) {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/information/findInformation?pid=${encodeURIComponent(pid)}`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res?.data?.data ?? false)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function confirmConsent() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/information/consent`;
        const body = {};
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.put(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}
